import type { FinReceitaFiltros, StatusReceita } from '../../types';

interface Props {
  filtros: FinReceitaFiltros;
  onChange: (f: FinReceitaFiltros) => void;
}

const inp = 'text-xs border border-gray-300 dark:border-gray-600 rounded px-2 py-1.5 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-200 focus:outline-none focus:ring-1 focus:ring-blue-400';

export function FiltrosFinanceiro({ filtros, onChange }: Props) {
  const set = (patch: Partial<FinReceitaFiltros>) => onChange({ ...filtros, ...patch });
  const temFiltro = !!(filtros.status || filtros.numero_processo || filtros.data_ini || filtros.data_fim);
  return (
    <div className="flex flex-wrap items-center gap-2">
      <select value={filtros.status ?? ''} onChange={(e) => set({ status: (e.target.value || '') as StatusReceita | '' })} className={inp}>
        <option value="">Todos os status</option>
        <option value="previsto">Previsto</option>
        <option value="parcial">Parcial</option>
        <option value="recebido">Recebido</option>
      </select>
      <input value={filtros.numero_processo ?? ''} onChange={(e) => set({ numero_processo: e.target.value })}
        placeholder="nº do processo" className={`${inp} w-44`} />
      <label className="text-[11px] text-gray-400">de</label>
      <input type="date" value={filtros.data_ini ?? ''} onChange={(e) => set({ data_ini: e.target.value })} className={inp} />
      <label className="text-[11px] text-gray-400">até</label>
      <input type="date" value={filtros.data_fim ?? ''} onChange={(e) => set({ data_fim: e.target.value })} className={inp} />
      {temFiltro && (
        <button type="button" onClick={() => onChange({})} className="text-[11px] text-blue-600 dark:text-blue-400 hover:underline">limpar</button>
      )}
    </div>
  );
}
